import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

ChartJS.register(ArcElement, Tooltip, Legend);


export default function Chart1({ totalJugadores, loading }) {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  const options = {
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },
    },
  };

  useEffect(() => {
    if (!totalJugadores || totalJugadores === 'empty' || totalJugadores.length === 0) {
      setChartData({
        labels: [],
        datasets: [],
      });
      return;
    }

    const total = totalJugadores.reduce((sum, item) => sum + item.total_jugadores, 0);

    const labels = totalJugadores.map(item => {
      const porcentaje = ((item.total_jugadores / total) * 100).toFixed(1);
      return `${item.nombre_survivor} (${porcentaje}%)`;
    });

    const data = totalJugadores.map(item => item.total_jugadores);

    const baseColors = ['#4e73df', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b', '#858796', '#5a5c69'];
    const repeatedColors = Array.from({ length: data.length }, (_, i) => baseColors[i % baseColors.length]);

    setChartData({
      labels,
      datasets: [
        {
          data,
          backgroundColor: repeatedColors,
        },
      ],
    });
  }, [totalJugadores]);

  const hasData = chartData.labels.length > 0 && chartData.datasets.length > 0;

  return (
    <div className="h-100 d-flex flex-column justify-content-center align-items-center">
      <div style={{ width: '100%', maxWidth: '350px' }}>
        {loading ? (
          <Skeleton height={300} />
        ) : hasData ? (
          <Pie data={chartData} options={options} />
        ) : (
          <p>No hay datos para mostrar.</p>
        )}
      </div>
    </div>
  );
}

